<span class="device-type-icon__glyph" [style.--device-icon]="maskImage()"></span>
